import { getTableVisibleColumns } from '../../../Table'
import { REQUEST_PROFILE_TAB_ACTIVITIES_TABLE_COLUMNS_CONFIG } from '../RequestProfileTabActivities.constants'
import { RequestProfileTabActivitiesTableRow } from '../RequestProfileTabActivitiesTableRow'

import * as styles from './RequestProfileTabActivitiesActivityDragOverlay.module.css'

function RequestProfileTabActivitiesActivityDragOverlay({ item }) {
  const columns = getTableVisibleColumns(
    REQUEST_PROFILE_TAB_ACTIVITIES_TABLE_COLUMNS_CONFIG
  )

  return (
    <div className={styles.RequestProfileTabActivitiesActivityDragOverlay}>
      <RequestProfileTabActivitiesTableRow
        disabled
        hideCheckbox
        actionsColumnWidth={0}
        columns={columns}
        item={item}
      />
    </div>
  )
}

export default RequestProfileTabActivitiesActivityDragOverlay
